export function serializeParameters(params) {
    return Object.keys(params).map((key) => {
        if (typeof params[key] === 'object') {
            return `${key}=${encodeURI(JSON.stringify(params[key]))}`;
        } else {
            return `${key}=${encodeURI(params[key])}`;
        }
    }).join('&');
}

export function getQueryParameters(url) {
    const str = (url || document.location.search).replace(/(^\?)/, '');

    return str.split('&').map(function (item) {
        return item = item.split('='), this[item[0]] = decodeURI(item[1]), this;
    }.bind({}))[0];
}

export function getCurrentRelativeUrl() {
    return window.location.pathname + window.location.search;
}

export function addParameters(url, params) {
    const href = url.split('?');
    const currentParams = href[1] ? getQueryParameters(href[1]) : {};

    return `${href[0]}?${serializeParameters(Object.assign(currentParams, params))}`;
}

export function setPageView(url) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'dm_page_view',
        'dm_page_path': url
    });
}

export function getReal(u64) {
    if(u64){
        if (u64.startsWith("DMU_")){
            let converted = atob(u64.replace("DMU_", ""));
            let splited = converted.split("?");
            const params = new URLSearchParams("?" + splited[1]);
            params.delete("os");
            let realUrl = splited[0];
            if (params.size > 0){
                realUrl += "?" + params;
            }
            return realUrl;
        }
    }
    return u64;
}

export function getRealProductListPage(obj){
    convertU64(obj);
    return obj;
}

function convertU64(obj){
    let keys = Object.keys(obj);
    for (let index in keys){
        let key = keys[index];
        let currentProperty = obj[key];
        if (currentProperty){
            if (typeof(currentProperty) === 'object'){
                convertU64(currentProperty);
            }
        }

        if (currentProperty && key.toLowerCase().endsWith("u64")){
            let newKey = key.replace("u64", "url").replace("U64", "Url");
            obj[newKey] = getReal(currentProperty);
        }
    }
}
